import React from 'react';

const colorMap = {
  blue:   { bg: '#dbeafe', color: '#1d4ed8' },
  green:  { bg: '#d1fae5', color: '#059669' },
  purple: { bg: '#ede9fe', color: '#7c3aed' },
  orange: { bg: '#ffedd5', color: '#ea580c' },
  red:    { bg: '#fee2e2', color: '#dc2626' },
  teal:   { bg: '#ccfbf1', color: '#0d9488' },
};

export default function StatCard({ label, value, icon, color = 'blue', subtitle, onClick }) {
  const { bg, color: c } = colorMap[color] || colorMap.blue;
  return (
    <div className="stat-card" onClick={onClick}
      style={onClick ? { cursor: 'pointer', transition: 'box-shadow 0.15s, transform 0.15s' } : {}}
      onMouseEnter={onClick ? e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.10)'; e.currentTarget.style.transform = 'translateY(-1px)'; } : undefined}
      onMouseLeave={onClick ? e => { e.currentTarget.style.boxShadow = ''; e.currentTarget.style.transform = ''; } : undefined}
    >
      <div className="stat-icon" style={{ background: bg, color: c }}>{icon}</div>
      <div style={{ flex: 1 }}>
        <div className="stat-label">{label}</div>
        <div className="stat-value">{value ?? <span style={{ opacity: 0.3 }}>—</span>}</div>
        {subtitle && <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 3 }}>{subtitle}</div>}
      </div>
    </div>
  );
}
